export default "__VITE_ASSET__DRIrMPd$__"